import React, { useState, useEffect, useCallback } from 'react';
import { observer } from 'mobx-react';
import HeaderRowSpanDataTable from 'components/data-table/HeaderRowSpanDataTable';
import ModalCustomerFinder from 'components/modals/ModalCustomerFinder';
import moment from 'moment';
import models from 'models';
import { $qb } from 'scripts/querybuilder';
import { useModal } from 'hooks/useModal';
import { useServices } from 'hooks/useServices';
import styled from 'styled-components';
import DatePicker from 'components/common/DatePicker';

const Input = styled.input`
  font-size: 12px;
  width: 150px;
  padding: 8px 38px 9px 20px;
  border: 1px solid #dee2ec;
  border-radius: 4px;
  height: 35px;

  &::placeholder {
    font-size: 12px;
  }
`;

const CustomersStatistics = () => {
  const modal = useModal();
  const services = useServices();

  const defaultParams = $qb()
    .limit(20)
    .orderBy('salesFigures desc')
    .customParam(
      'searchStartAt',
      moment(new Date().setDate(new Date().getDate() - 31)).format('YYYY-MM-DD')
    )
    .customParam(
      'searchEndAt',
      moment(new Date().setDate(new Date().getDate() - 1)).format('YYYY-MM-DD')
    );
  const [params, setParams] = useState(defaultParams);
  const [searchValue, setSearchValue] = useState({
    searchStartAt: moment(new Date().setDate(new Date().getDate() - 31)).format(
      'YYYY-MM-DD'
    ),
    searchEndAt: moment(new Date().setDate(new Date().getDate() - 1)).format(
      'YYYY-MM-DD'
    ),
  });
  const [startAt, setStartAt] = useState(
    new Date().setDate(new Date().getDate() - 31)
  );
  const [endAt, setEndAt] = useState(
    new Date().setDate(new Date().getDate() - 1)
  );
  const [input, setInput] = useState('');
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [model, setModel] = useState(models.crm.customerStatistics);
  const [tabName, setTabName] = useState('customer');
  //const [customer, setCustomer] = useState('');
  //const [downloadBtnDisabledFlag, setDownloadBtnDisabledFlag] = useState(false);

  const customerStatisticsCallApi = useCallback(async () => {
    const resp = await services.crm.statistics.statistics.customer(
      params.build()
    );
    if (!resp) return;
    resp.data.customerData.map((v, i) => {
      let page = params.queryParams.page || 1;
      let limit = params.queryParams.limit;
      let no = parseInt((page - 1) * limit + (i + 1));
      v.no = no;
      return v;
    });

    setData(resp.data.customerData);
    setTotal(resp.meta.pagination.total);
    setModel(models.crm.customerStatistics);
  }, [services.crm.statistics, params, models.crm.customerStatistics]);

  useEffect(() => {
    customerStatisticsCallApi();
  }, [customerStatisticsCallApi]);

  const rankStatisticsCallApi = useCallback(async () => {
    const resp = await services.crm.statistics.statistics.customer_level(
      params.build()
    );
    if (!resp) return;
    resp.data.customerData.map((v, i) => {
      let page = params.queryParams.page || 1;
      let limit = params.queryParams.limit;
      let no = parseInt((page - 1) * limit + (i + 1));
      v.no = no;
      return v;
    });
    setData(resp.data.customerData);
    setTotal(resp.meta.pagination.total);
    setModel(models.crm.rankStatistics);
  }, [services.crm.statistics, params, models.crm.rankStatistics]);

  const onParams = (p) => {
    setParams(p);
    callApi(tabName);
  };

  const callApi = (type) => {
    if (type === 'rank') {
      rankStatisticsCallApi();
    } else if (type === 'customer') {
      customerStatisticsCallApi();
    }
  };

  /*const onClickSelectDate = (v) => {
    const now = new Date();
    if (v === 'month') {
      onChangeDate(
        new Date(now.getFullYear(), now.getMonth(), 1),
        new Date(now.getFullYear(), now.getMonth() + 1, 0)
      );
    } else if (v === 'week') {
      const nowDayOfWeek = now.getDay();
      const nowDay = now.getDate();
      const nowMonth = now.getMonth();
      let nowYear = now.getYear();
      nowYear += nowYear < 2000 ? 1900 : 0;
      const weekStartDate = new Date(nowYear, nowMonth, nowDay - nowDayOfWeek);
      const weekEndDate = new Date(
        nowYear,
        nowMonth,
        nowDay + (6 - nowDayOfWeek)
      );
      onChangeDate(weekStartDate, weekEndDate);
    } else if (v === 'quarter') {
      const currentMonth = now.getMonth() + 1;
      const quarter = Math.ceil(currentMonth / 3);
      const startDate = new Date(now.getFullYear(), (quarter - 1) * 3, 1);
      const endDate = new Date(now.getFullYear(), quarter * 3, 0);
      onChangeDate(startDate, endDate);
    }
  };

  const onChangeDate = (startDate, endDate) => {
    setStartAt(startDate);
    setEndAt(endDate);
    setSearchValue({
      ...searchValue,
      searchStartAt: moment(startDate).format('YYYY-MM-DD'),
      searchEndAt: moment(endDate).format('YYYY-MM-DD'),
    });
  };*/

  const onChangeStartAt = (date) => {
    const searchStartAt = moment(date).format('YYYY-MM-DD');
    setStartAt(date);
    setSearchValue({ ...searchValue, searchStartAt });
  };

  const onChangeEndAt = (date) => {
    const searchEndAt = moment(date).format('YYYY-MM-DD');
    setEndAt(date);
    setSearchValue({ ...searchValue, searchEndAt });
  };

  const onClickHeaderRow = (row) => {
    let orderBy = `${row.column} ${row.order}`;
    params.orderBy(orderBy);
    callApi(tabName);
  };

  const searchUser = (value) => {
    modal
      .custom({
        component: ModalCustomerFinder,
        options: {
          customerData: { searchQuery: value },
        },
      })
      .then((customer) => {
        if (customer) {
          setInput(customer.name);
          onClickSelect('customer', customer.id);
        }
      });
  };

  const onClickSearch = (type) => {
    if (type === 'customer' && input) {
      searchUser(input);
    } else {
      onClickSelect(type);
    }
  };

  const onClickSelect = (type, id = '') => {
    let searchParam = searchValue;
    if (searchParam.searchStartAt === 'Invalid date') {
      // eslint-disable-next-line no-unused-vars
      const { searchStartAt: deletedKey, ...otherKeys } = searchParam;
      searchParam = otherKeys;
    }

    if (searchParam.searchEndAt === 'Invalid date') {
      // eslint-disable-next-line no-unused-vars
      const { searchEndAt: deletedKey, ...otherKeys } = searchParam;
      searchParam = otherKeys;
    }

    if (type === 'customer' && input) {
      searchParam.customerIds = id;
    } else {
      delete searchParam.customerIds;
    }
    params.queryParams = {
      limit: params.queryParams.limit,
      orderBy: params.queryParams.orderBy,
      ...searchParam,
    };

    if (type === 'rank') delete params.queryParams.orderBy;
    if (type === 'customer' && !params.queryParams.orderBy)
      params.queryParams.orderBy = 'consultedCount desc';

    setSearchValue(searchParam);
    let unit = typeof type === 'string' ? type : tabName;
    setParams(params);
    callApi(unit);
  };

  return (
    <div className={`statistics list inquiry`}>
      <div className="page-navi">
        <span className="title">통계</span>
        <span className="title">환자 통계</span>
      </div>

      <div className="route-top customer-tab-line">
        <div className="tabwrap">
          <ul>
            <li
              onClick={() => {
                params.orderBy('salesFigures desc');
                onClickSearch('customer');
                setTabName('customer');
              }}
              className={`tab ${
                tabName && tabName === 'customer' ? 'selected' : ''
              }`}
            >
              <a>고객별</a>
            </li>
            <li
              onClick={() => {
                setInput('');
                params.orderBy('salesFigures desc');
                onClickSearch('rank');
                setTabName('rank');
              }}
              className={`tab ${
                tabName && tabName === 'rank' ? 'selected' : ''
              }`}
            >
              <a>고객등급별</a>
            </li>
          </ul>
        </div>
      </div>

      <div className="route-top">
        <div className="search-bar">
          {/* <div className="search-btns">
            <button
              className={`btn btn-normal _small`}
              onClick={() => onClickSelectDate('week')}
            >
              이번 주
            </button>
          </div>
          <div className="search-btns">
            <button
              className={`btn btn-normal _small`}
              onClick={() => onClickSelectDate('month')}
            >
              이번 달
            </button>
          </div>
          <div className="search-btns">
            <button
              className={`btn btn-normal _small`}
              onClick={() => onClickSelectDate('quarter')}
            >
              이번 분기
            </button>
          </div> */}
          <div className="search-item">
            <DatePicker
              className="text-center"
              placeholderText="날짜선택"
              todayButton="오늘"
              maxDate={new Date()}
              value={startAt}
              onChange={onChangeStartAt}
            />
          </div>
          <div className="search-item">-</div>
          <div className="search-item">
            <DatePicker
              className="text-center"
              placeholderText="날짜선택"
              todayButton="오늘"
              maxDate={new Date()}
              value={endAt}
              onChange={onChangeEndAt}
            />
          </div>
          {tabName && tabName === 'customer' ? (
            <div className="search-item">
              <Input
                value={input || ''}
                placeholder="고객명"
                onChange={(e) => {
                  setInput(e.target.value);
                }}
              />
            </div>
          ) : null}
          <div className="search-btns">
            <button
              className="btn btn-basic _small search"
              onClick={() => onClickSearch(tabName)}
            >
              조회
            </button>
            {/* <button
              className="btn btn-basic _small excel"
              disabled={downloadBtnDisabledFlag}
              //onClick={onClickExcelDownload}
              >Excel 내려받기 </button> */}
          </div>
        </div>
      </div>
      <div className="sales-statistics-container">
        <HeaderRowSpanDataTable
          rowKey="no"
          model={model}
          data={data}
          total={total}
          onClickHeaderRow={onClickHeaderRow}
          params={params}
          onParams={onParams}
          bordered={true}
        />
      </div>
    </div>
  );
};

export default observer(CustomersStatistics);
